export default __webpack_public_path__ + "static/media/Group 6501@3x.1cbfaee7.png";